module.exports = __webpack_public_path__ + "media/img/pages/companies/bank-cler-db01c8962e8b908d4e2f06c278bd8efc.png";